import React, { FC } from 'react';

import classnames from 'classnames';
import { TitleProps } from './models';
import './Title.scss';

const Title: FC<TitleProps> = ({ text, className }) => (
  <h2 className={classnames('title', className)}>{text}</h2>
);

export default Title;
